import { h } from 'preact';
const  back = (props) => (
	<svg id="back" viewBox="0 0 72 72" class={props.class}>
		<polygon points="70,31.8 18.2,31.8 41.9,7.9 36,2 2,36 36,70 41.9,64.1 18.2,40.2 70,40.2 " />
	</svg>
);
export default back;


// WEBPACK FOOTER //
// ../q-components/components/icons/headerIcons/back/index.js